<script lang="ts">
	import AriaText from "@components/common/AriaText.svelte";
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import { isEnum } from "@core/utils/enum/isEnum.js";
	import { type ButtonSize, ButtonVariant } from "./getButtonClass.js";
	import { getButtonClass } from "./getButtonClass.js";
	import { type LinkVariant, getLinkClass } from "./getLinkClass.js";

	const isButtonVariant = isEnum(ButtonVariant);
	const {
		variant,
		size,
		...rest
	}: { variant?: ButtonVariant | LinkVariant; size?: ButtonSize } & HTMLAnchorAttributes = $props();
</script>

<a {...rest} class={[isButtonVariant(variant) ? getButtonClass(variant, size) : getLinkClass(variant), rest.class]}>
	<AriaText aria={rest["aria-label"] ?? ""}>
		{@render rest.children?.()}
	</AriaText>
</a>
